export default {
  sitemap: {
    title: 'Sitemap',
    sections: {
      general: 'General',
      categories: 'Kategorien',
      cities: 'Städte',
      cityCategories: 'Städte und Kategorien',
      generalTransactionalPages: 'Verschiedene Themen',
      teamEvents: 'Teamevents',
      events: 'Kurse und Workshops',
      partnerProfiles: 'Partner Profile',
      articles: 'Magazin-Artikel',
      kits: 'DIY-Boxen Kategorien',
    },
    pagesLabelTitles: {
      city: 'Kurse in {title}',
      category: '{title}',
      cityCategory: '{title}',
      generalTransactionalPage: '{title}',
    },
    pathTitles: {
      '/': 'Home',
      '/contactUs/': 'Kontakt',
      '/faq/': 'Häufige Fragen',
      '/impressum/': 'Impressum',
      '/_nuxt3-static/partner/': 'Werde Partner',
      '/terms-and-conditions/': 'AGB',
      '/terms-supplier/': 'Angebotsanbieter-AGB',
      '/teamevent/': 'Teamevent',
      '/giftcard/': 'Giftcard',
      '/_nuxt3-static/partner/pricing/': 'Partner Pricings',
    },
  },
}
